export const defaultCurrencyDecimalScale = 2
export const defaultCurrencyFillDecimalScale = 'onBlur'
export const defaultCurrencyInputPrefix = '$'
